import { useCallback, useState } from 'react'

function useLocalStorage(key, initialValue) {
  // ? Faccio i check su Window per evitare Crash dovuti al SSR
  const [storedValue, setStoredValue] = useState(() => {
    try {
      if (typeof window !== 'undefined') {
        const item = window.localStorage.getItem(key)
        return item ? JSON.parse(item) : initialValue
      }
    } catch (error) {
      console.log(error)
      return initialValue
    }
  })

  // ? Versione Wrappata del setState => per settare il Valore Nuovo
  const setValue = useCallback((value) => {
    try {
      if (typeof window !== 'undefined') {
        setStoredValue((prevStoredValue) => {
          const valueToStore = value instanceof Function ? value(prevStoredValue) : value
          window.localStorage.setItem(key, JSON.stringify(valueToStore))
          return valueToStore
        })
      }
    } catch (error) {
      console.log(error)
    }
  }, [key])

  return [storedValue, setValue]
}

export default useLocalStorage
